import React from "react";
import { useTranslation } from "src/_common/hooks/useTranslation";
import "./video-controls.css";

interface VideoControlsProps {
  isVideoMuted: boolean;
  isAudioMuted: boolean;
  onToggleVideo: () => void;
  onToggleAudio: () => void;
  onLeaveCall: () => void;
  isRecording?: boolean;
  onToggleRecording?: () => void;
  showRecordingButton?: boolean;
  elapsedTime?: string;
}

const VideoControls: React.FC<VideoControlsProps> = ({
  isVideoMuted,
  isAudioMuted,
  onToggleVideo,
  onToggleAudio,
  onLeaveCall,
  isRecording = false,
  onToggleRecording,
  showRecordingButton = false,
  elapsedTime,
}) => {
  const { t } = useTranslation("settings");
  
  return (
    <div className="drjob-iv-controls-panel">
      <div className="drjob-iv-controls-inner">
        {/* Audio Control */}
        <button
          className={`drjob-iv-control-button ${isAudioMuted ? "drjob-iv-muted" : ""}`}
          onClick={onToggleAudio}
          title={isAudioMuted ? t("instantMeet.videoControls.unmuteAudio") : t("instantMeet.videoControls.muteAudio")}
        >
          <i
            className={`fa ${isAudioMuted ? "fa-microphone-slash" : "fa-microphone"}`}
            style={{ fontSize: "24px" }}
          ></i>
          <span className="drjob-iv-control-label">{isAudioMuted ? t("instantMeet.videoControls.unmute") : t("instantMeet.videoControls.mute")}</span>
        </button>

        {/* Video Control */}
        <button
          className={`drjob-iv-control-button ${isVideoMuted ? "drjob-iv-muted" : ""}`}
          onClick={onToggleVideo}
          title={isVideoMuted ? t("instantMeet.videoControls.turnOnCamera") : t("instantMeet.videoControls.turnOffCamera")}
        >
          <i className={`fa ${isVideoMuted ? "fa-video-slash" : "fa-video-camera"}`} style={{ fontSize: "24px" }}></i>
          <span className="drjob-iv-control-label">{isVideoMuted ? t("instantMeet.videoControls.startVideo") : t("instantMeet.videoControls.stopVideo")}</span>
        </button>

        {/* Recording Control - Only shown for host */}
        {showRecordingButton && onToggleRecording && (
          <button
            className={`drjob-iv-control-button ${isRecording ? "drjob-iv-recording" : ""}`}
            onClick={onToggleRecording}
            title={isRecording ? t("instantMeet.videoControls.stopRecording") : t("instantMeet.videoControls.startRecording")}
          >
            <i className={`fa ${isRecording ? "fa-stop-circle" : "fa-circle"}`} style={{ fontSize: "24px" }}></i>
            <span className="drjob-iv-control-label">{isRecording ? t("instantMeet.videoControls.stopRecording") : t("instantMeet.videoControls.record")}</span>
          </button>
        )}

        {/* Timer Display */}
        {elapsedTime && (
          <div className="drjob-iv-timer-display">
            <i className="fa fa-clock-o" style={{ fontSize: "18px", marginRight: "8px" }}></i>
            {t("instantMeet.videoControls.remainingTime")} <span className="ml-2 pl-2">{elapsedTime}</span>
          </div>
        )}

        {/* Leave Call Button */}
        <button
          className="drjob-iv-control-button drjob-iv-leave-button"
          onClick={() => onLeaveCall()}
          title={t("instantMeet.videoControls.leaveInterview")}
        >
          <i className="fa fa-phone" style={{ fontSize: "24px", transform: "rotate(135deg)" }}></i>
          <span className="drjob-iv-control-label">{t("instantMeet.videoControls.leave")}</span>
        </button>
      </div>
    </div>
  );
};

export default VideoControls;
